import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchSummary(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/show_process/fetch_summary/${agro_exporter_process_id}`
    );
  },
  fetchExportPortsOrigin(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_export_ports_origin/${agro_exporter_process_id}`
    );
  },
  fetchExportPortsDestination(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_export_ports_destination/${agro_exporter_process_id}`
    );
  },
  fetchIntermediatedAgroExporters(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_intermediated_agro_exporters/${agro_exporter_process_id}`
    );
  },
  fetchShippingLines(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_shipping_lines/${agro_exporter_process_id}`
    );
  },
  fetchCustomers(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_customers/${agro_exporter_process_id}`
    );
  },
  fetchExporterProcessBrands(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_exporter_process_brands/${agro_exporter_process_id}`
    );
  },
  fetchExporterProcessContainerAttributes(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_exporter_process_container_attributes/${agro_exporter_process_id}`
    );
  },
  fetchAgroExporterPackageWrappers(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_agro_exporter_package_wrappers/${agro_exporter_process_id}`
    );
  },
  fetchExportationStatuses(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_exportation_statuses/${agro_exporter_process_id}`
    );
  },
  fetchContainerStatuses(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_container_statuses/${agro_exporter_process_id}`
    );
  },
  fetchPackingHouseProcesses(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_packing_house_processes/${agro_exporter_process_id}`
    )
  },
  fetchProducersOrganizations(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_producers_organizations/${agro_exporter_process_id}`
    )
  },
  fetchExportSealings(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_export_sealings/${agro_exporter_process_id}`
    )
  },
  fetchExporterProcessIntermediates(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/query/fetch_exporter_process_intermediates/${agro_exporter_process_id}`
    )
  }
};
